import { render } from "./LightboxCategoryRevenueSkeleton.vue?vue&type=template&id=026320b6&scoped=true"
import script from "./LightboxCategoryRevenueSkeleton.vue?vue&type=script&lang=js"
export * from "./LightboxCategoryRevenueSkeleton.vue?vue&type=script&lang=js"

import "./LightboxCategoryRevenueSkeleton.vue?vue&type=style&index=0&id=026320b6&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-026320b6"]])

export default __exports__